import { g as getNumberFormat } from './formatNumber-_rBNDjjP-B-cxWpqK.js';

/**
 * @param {number} value The value to format.
 * @param {string} locale A string with a BCP 47 language tag, or an array of such strings.
 * @param {string} currency Currency formatting.
 * Possible values are the ISO 4217 currency codes, such as "USD" for the US dollar, "EUR" for the euro.
 */
const formatCurrency = getNumberFormat(({
  currency
}) => ({
  style: 'currency',
  currencyDisplay: 'symbol',
  signDisplay: 'auto',
  currency
}));

export { formatCurrency as f };
//# sourceMappingURL=formatCurrency-D8tnTBC2-C_-2yL1G.js.map
